import $ from 'jquery';
window.$ = $;
window.jQuery = $;
export default $;



// WEBPACK FOOTER //
// ../src/assets/js/jqueryexport.js